import { render, staticRenderFns } from "./DsfrPhoneNumber.vue?vue&type=template&id=cbcb7458&"
import script from "./DsfrPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./DsfrPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports